import React, { useState, useEffect, useRef } from 'react'
import { motion, useScroll } from 'framer-motion'
import 'react-tabs/style/react-tabs.css'

import TabListDesktop from './parts/TabListDesktop';
import TabListMobile from './parts/TabListMobile';

import Skills from './parts/Skills';

import Lines from './parts/Lines';

export default function Experience() {
  const [matches, setMatches] = useState(
    window.matchMedia("(min-width: 768px)").matches
  )

    useEffect(() => {
      window
      .matchMedia("(min-width: 768px)")
      .addEventListener('change', e => setMatches( e.matches ));
    }, []);

    return (
     <>
       <div id="experience" className="container experience">
       <div className="row">
       <div className="col-md-8 tabs">
        <div className="ui-experience">
           <div className="ui-text">Work Experience</div>
        </div>
          {matches && <TabListDesktop />}
          {!matches && <TabListMobile />}
         </div>

        <div className="col-md-3 skills">
          <div className="ui-experience">
             <div className="ui-text">Skills</div>
          </div>
              <Skills></Skills>
          </div>
        </div>
       </div>
       <Lines></Lines>
     </>
  );
}
